import type { ButtonHTMLAttributes } from "react";
import styles from "./Button.module.css";

/** primary=acción principal · secondary=acción alterna suave · ghost=terciaria ·
 *  danger=destructiva · sun/coral=capa niño (compatibilidad). */
type Variant = "primary" | "secondary" | "ghost" | "danger" | "sun" | "coral";
type Size = "sm" | "md";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  /** Tamaño denso opcional; omitido = tamaño base histórico (sin regresión). */
  size?: Size;
  block?: boolean;
  /** Muestra spinner y deshabilita (evita doble submit). */
  loading?: boolean;
}

export function Button({
  variant = "primary",
  size,
  block,
  loading,
  className,
  disabled,
  children,
  ...rest
}: Props) {
  const cls = [
    styles.btn,
    styles[variant],
    size ? styles[size] : "",
    block ? styles.block : "",
    loading ? styles.loading : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <button
      className={cls}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <span className={styles.spinner} aria-hidden="true" /> : null}
      {children}
    </button>
  );
}
